import {getBackendURL} from './Backend';
import axios from 'axios';
import {toIsoString} from "./utils/DateUtils";

const jsonConfigs = {
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  }
};

const downloadConfigs = {
  withCredentials: true,
  responseType: 'arraybuffer', // Important
  headers: {
    // 'Content-Type': 'application/json',
    'Accept': 'application/pdf',
  }
};

function __handle_response(response) {
  console.debug("Server response: ", response);  // Comment me for prod
  return response;
}

function __handle_error(error) {
  console.debug("Server response error: ", error);  // Comment me for prod
  if (error.response && error.response.data && error.response.data.detail) {
    const detail = error.response.data.detail;
    if ( typeof detail === 'string') {
      throw new Error(detail);
    } else {
      throw new Error(JSON.stringify(detail, null, 2));
    }
  } else if (error.message){
    throw new Error(error.message);
  } else {
    // The request was made but no response was received
    throw new Error("Server cannot be reached or unexpected exception");
  }
}

function get_then_catch(url) {
  return axios
    .get(url,{withCredentials: true})
    .then(__handle_response)
    .catch(__handle_error);
}


export function getMyIdentity() {
  const url = getBackendURL() + "/unltd/user_get_me"
  return get_then_catch(url)
}


export function getSiteAdminList(searchString='', skip=0, limit=2) {
  const url = getBackendURL() + `/unltd/user_get_list_site_administrator?search_string=${searchString}&skip=${skip}&limit=${limit}`
  return get_then_catch(url)
}


export function getClinicianList(searchString='', skip=0, limit=2) {
  const url = getBackendURL() + `/unltd/user_get_list_clinician?search_string=${searchString}&skip=${skip}&limit=${limit}`
  return get_then_catch(url)
}


export function getPatientList(searchString='', skip=0, limit=2) {
  const url = getBackendURL() + `/unltd/user_get_list_patient?search_string=${searchString}&skip=${skip}&limit=${limit}`
  return get_then_catch(url)
}


export function sendPasswordResetLink(passwordRecoveryEmail='') {
  const url = getBackendURL() + `/unltd/send_email_password_recovery?email_recipient=${passwordRecoveryEmail}`
  return get_then_catch(url)
}

export function user_confirm_password(password='') {
  const url = getBackendURL() + `/unltd/user_confirm_password`

  const data = {
    password: password
  };

  return axios
      .post(url, data, jsonConfigs)
      .then(__handle_response)
      .catch(__handle_error);
}

export function user_set_password(password='') {
  const url = getBackendURL() + `/unltd/user_set_password`

  const data = {
    password: password
  };

  return axios
      .post(url, data, jsonConfigs)
      .then(__handle_response)
      .catch(__handle_error);
}

export function settings_web_user_get(user_id = '') {
  const url = getBackendURL() + `/unltd/settings_web_user_get?user_id=${user_id}`
  return axios
      .get(url,{withCredentials: true})
}

export function settings_web_user_set(user_id = '', data_dict = {}) {
  const url = getBackendURL() + `/unltd/settings_web_user_set?user_id=${user_id}`

  const data = data_dict

  return axios
      .post(url, data, jsonConfigs)
      .then(__handle_response)
      .catch(__handle_error);
}

export function settings_web_user_add(data_dict={}) {
  const url = getBackendURL() + `/unltd/settings_web_user_add`

  const data = data_dict

  return axios
      .post(url, data, jsonConfigs)
      .then(__handle_response)
      .catch(__handle_error);
}

function __addUser(url, username, family_name, given_name, email_address) {
  const data = {
    username: username,
    // password: password,
    family_name: family_name,
    given_name: given_name,
    email_address: email_address
  };

  return axios
    .post(url, data, jsonConfigs)
    .then(__handle_response)
    .catch(__handle_error);
}

export function addSiteAdmin(username, family_name, given_name, email_address) {
  const url = getBackendURL() + `/unltd/user_add_site_administrator`
  return __addUser(url, username, family_name, given_name, email_address)
}

export function addClinician(username, family_name, given_name, email_address) {
  const url = getBackendURL() + `/unltd/user_add_clinician`
  return __addUser(url, username, family_name, given_name, email_address)
}

export function addPatient(username, family_name, given_name, email_address) {
  const url = getBackendURL() + `/unltd/user_add_patient`
  return __addUser(url, null, family_name, given_name, email_address)
}

export function sendEmailUponAddingSiteAdmin(username, password, email_address) {
  const url = getBackendURL() + `/unltd/send_email_user_add_site_administrator?username=${username}&password=${password}&email_address_recipient=${email_address}`
  return get_then_catch(url)
}

export function sendEmailUponAddingClinician(username, password, email_address) {
  const url = getBackendURL() + `/unltd/send_email_user_add_clinician?username=${username}&password=${password}&email_address_recipient=${email_address}`
  return get_then_catch(url)
}

export function sendEmailUponAddingPatient(username, password, email_address) {
  const url = getBackendURL() + `/unltd/send_email_user_add_patient?username=${username}&password=${password}&email_address_recipient=${email_address}`
  return get_then_catch(url)
}

export function editSiteAdministrator(userInfo) {
  const url = getBackendURL() + `/unltd/user_set_site_administrator?user_id=${userInfo.id}`

  const data = {
    username: userInfo.username,
    family_name: userInfo.familyName,
    given_name: userInfo.givenName,
    email_address: userInfo.email
  };

  return axios
    .post(url, data, jsonConfigs)
    .then(__handle_response)
    .catch(__handle_error);
}

export function editClinician(userInfo) {
  const url = getBackendURL() + `/unltd/user_set_clinician?user_id=${userInfo.id}`

  const data = {
    username: userInfo.username,
    family_name: userInfo.familyName,
    given_name: userInfo.givenName,
    email_address: userInfo.email
  };

  return axios
    .post(url, data, jsonConfigs)
    .then(__handle_response)
    .catch(__handle_error);
}

export function editPatient(userInfo) {
  const url = getBackendURL() + `/unltd/user_set_patient?user_id=${userInfo.id}`

  const data = {
    family_name: userInfo.familyName,
    given_name: userInfo.givenName,
    email_address: userInfo.email
  };

  return axios
    .post(url, data, jsonConfigs)
    .then(__handle_response)
    .catch(__handle_error);
}


export function createSession(patientId, gameId) {
  const url = getBackendURL() + '/unltd/session_add'

  const data = {
    patient_id: patientId,
    scene_id: gameId,
    datetime_iso8601: toIsoString(new Date(Date.now()))
  };

  return axios
    .post(url, data, jsonConfigs)
    .then(__handle_response)
    .catch(__handle_error);
}


export function getPatientSessionList(patientString='' ) {
  const url = getBackendURL() + `/unltd/session_get_list_all?patient_id=${patientString}`
  return get_then_catch(url)
}

export function getSessionInfo(sessionId='' ) {
  const url = getBackendURL() + `/unltd/session_get?session_id=${sessionId}`
  return get_then_catch(url)
}

export function getSessionRecording(sessionId='' ) {
  const url = getBackendURL() + `/unltd/session_get_recordings?session_id=${sessionId}`
  return get_then_catch(url)
}

export function getGameLibrary() {
  const url = getBackendURL() + `/unltd/scene_get_list_all`
  return get_then_catch(url)
}

export function getSceneInfo(scene_id) {
  const url = getBackendURL() + `/unltd/scene_get?scene_id=${scene_id}`
  return get_then_catch(url)
}

function fileDownload(blob, filename) {
  const objectURL = URL.createObjectURL( blob );
  const link = document.createElement( 'a' );
  link.style.display = 'none';
  document.body.appendChild( link );
  link.href = objectURL;
  link.href = URL.createObjectURL( blob );
  link.download =  filename;
  link.click();
}

export function downloadProtectedFile(server_file_path, filename) {
  const url = getBackendURL() + `/unltd/protected_files/${server_file_path}`
  return axios.get(url, downloadConfigs).then(response => {
    // Would be good if we could get the filename from content-disposition
    // const contentDisposition = response.headers['content-disposition'];
    // console.log('$$$ contentDisposition: ', contentDisposition);
    const blob = new Blob([response.data], {
      type: 'application/pdf',
    });
    fileDownload(blob, filename);
  })
}

export function createDeviceToken(session_id) {
  // token returned as response.data.access_token
  const url = getBackendURL() + `/unltd/bearer/create_device_token?session_id=${session_id}`
  const data = {};

  return axios
    .post(url, data, jsonConfigs)
    .then(__handle_response)
    .catch(__handle_error);
}

